module.exports = __webpack_public_path__ + "static/media/screen3-3.2c408682.jpg";